// extracted by mini-css-extract-plugin
export default {"form":"CheckoutForm_form__h9Z+-","form__error":"CheckoutForm_form__error__x2g0N","form__message":"CheckoutForm_form__message__ypEqw"};